import React from "react";

function ProjectStatusBubble(props) {
  const { status } = props;
  let statusCaption = "";
  let statusClass = "";
  switch (status) {
    case "ADVERTISED":
      statusCaption = "Advertised";
      statusClass = "warning";
      break;
    case "PRE_CONST":
      statusCaption = "Pre-Const";
      statusClass = "info";
      break;
    case "IN_CONST":
      statusCaption = "In-Const";
      statusClass = "success";
      break;
    case "POST_CONST":
      statusCaption = "Post-Const";
      statusClass = "secondary";
      break;
    default:
      break;
  }
  statusClass = "span-bubble p-1 bg-" + statusClass;
  return status ? <span className={statusClass}>{statusCaption}</span> : "(N/A)";
}

export default ProjectStatusBubble;
